import { MaskedLine, FadeUp, Eyebrow } from "@/components/Reveal";
import { Vine, FloatLeaf } from "@/components/Botanical";

const SECTIONS = [
  {
    n: "1",
    title: "Who we are",
    body: "Salon Orgænics is a brand of Saloneur Technologies Private Limited (CIN: U63122PN2026PTC252764), registered office at 676, Vastukalp Society, Bibvewadi, Pune 411014, operating from VJ Yashwin Orrizonte, near Panchshil Towers, Kharadi, Pune 411014. This policy explains how we handle your personal information under the Digital Personal Data Protection Act, 2023 and applicable Indian law.",
  },
  {
    n: "2",
    title: "What we collect",
    body: "Your name, phone number and e-mail address; appointment and service history; membership enrolment details; health or allergy information you choose to share with us so we can serve you safely; and basic website usage information.",
  },
  {
    n: "3",
    title: "How we use it",
    body: "To book and deliver your appointments, keep you safe during chemical and skin services, administer your membership, share offers you have agreed to receive, and meet legal and accounting obligations.",
  },
  {
    n: "4",
    title: "Storage, not sharing",
    body: "We store your data securely and access is limited to team members who need it to serve you. We do not sell, rent, trade or otherwise share your personal data with advertisers, data brokers or any unrelated party.",
  },
  {
    n: "5",
    title: "The only exceptions",
    body: "Your data leaves us only where a service genuinely requires it: our booking platform (Dingg) receives the details needed to confirm your appointment; where you upload or register information directly with a product manufacturer (OEM) — for example brand warranty or loyalty programmes — that data goes straight to them under their own privacy policies; and third-party agencies or authorities where the law requires disclosure. We never route your data through intermediaries for marketing.",
  },
  {
    n: "6",
    title: "Photographs",
    body: "Photos or videos of your service results are taken and shared only with your consent, as set out in our Terms & Conditions.",
  },
  {
    n: "7",
    title: "Your rights",
    body: "You may ask to see, correct or delete the personal data we hold about you at any time. Write to us and we will act on genuine requests promptly, subject to records we must keep by law.",
  },
  {
    n: "8",
    title: "Contact",
    body: "For anything about your data: Salon Orgænics, VJ Yashwin Orrizonte, near Panchshil Towers, Kharadi, Pune 411014 · +91 91580 00424 · admin.saloneur@gmail.com.",
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="relative bg-[#F9FAF8] overflow-hidden pt-36 pb-14">
        <Vine className="absolute right-8 top-24 h-[55%] w-auto opacity-30" flip />
        <FloatLeaf className="w-24 left-[14%] top-[26%] opacity-25" delay={0.4} />
        <div className="max-w-[1000px] mx-auto px-6 md:px-12 relative z-10">
          <MaskedLine onLoad className="mb-6">
            <Eyebrow>Your data, kept close</Eyebrow>
          </MaskedLine>
          <h1 className="font-display font-light leading-[0.95] tracking-tight text-[#0A0A0A]">
            <MaskedLine onLoad delay={0.15} className="text-[11vw] md:text-7xl">
              <span>Privacy <span className="italic text-[#11261A]">Policy</span></span>
            </MaskedLine>
          </h1>
          <FadeUp delay={0.35}>
            <p className="mt-6 text-base md:text-lg text-[#4A4A4A] max-w-xl leading-relaxed">
              The short version: we store what we need to care for you — and we do not share it,
              except where a service you use sends data directly to its provider.
            </p>
          </FadeUp>
        </div>
      </section>

      <section className="bg-white py-14 md:py-20">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <div className="space-y-10" data-testid="privacy-sections">
            {SECTIONS.map((s) => (
              <FadeUp key={s.n}>
                <div className="grid md:grid-cols-12 gap-5 items-start border-t border-[#E5E7E3] pt-10">
                  <span className="md:col-span-2 font-display font-light text-4xl text-[#11261A]/20">{s.n}.</span>
                  <div className="md:col-span-10">
                    <h2 className="font-display font-light text-2xl md:text-3xl tracking-tight text-[#0A0A0A]">{s.title}</h2>
                    <p className="mt-4 text-sm md:text-base text-[#4A4A4A] leading-relaxed">{s.body}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
